import { Phone, Instagram, Ghost, Clock } from "lucide-react";

export default function Contact({ onBookNow }) {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-32 border-t border-stone-900"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
        <div className="md:col-span-6">
          <div className="text-[10px] tracking-[0.3em] uppercase text-amber-500/80 mb-4">
            Get in Touch
          </div>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight text-stone-50 leading-tight">
            Ready when
            <br />
            <span className="italic text-amber-500">you are.</span>
          </h2>
          <p className="mt-8 text-stone-300 text-base md:text-lg max-w-md leading-relaxed">
            Slide into the DMs, give a call, or book your chair online. Andaz
            replies personally — no bots, no wait.
          </p>
          <button
            data-testid="contact-book-btn"
            onClick={onBookNow}
            className="mt-10 bg-amber-500 text-stone-950 px-8 py-4 text-xs tracking-[0.2em] uppercase font-medium hover:bg-amber-400 transition-colors duration-300"
          >
            Book Online
          </button>
        </div>

        <div className="md:col-span-6 space-y-4">
          <a
            href="tel:+14025706030"
            data-testid="contact-phone"
            className="group flex items-center justify-between border border-stone-800 hover:border-amber-500/50 bg-stone-900/50 p-6 transition-colors duration-300"
          >
            <div className="flex items-center gap-5">
              <div className="w-12 h-12 border border-stone-800 flex items-center justify-center text-amber-500 group-hover:bg-amber-500 group-hover:text-stone-950 transition-colors duration-300">
                <Phone size={18} />
              </div>
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-stone-500">
                  Call / Text
                </div>
                <div className="text-stone-50 font-display text-lg mt-1">
                  +1 (402) 570-6030
                </div>
              </div>
            </div>
            <span className="text-stone-500 text-sm group-hover:text-amber-500 transition-colors duration-300">
              tap →
            </span>
          </a>

          <a
            href="https://www.instagram.com/andooozy.cutzz"
            target="_blank"
            rel="noreferrer"
            data-testid="contact-instagram"
            className="group flex items-center justify-between border border-stone-800 hover:border-amber-500/50 bg-stone-900/50 p-6 transition-colors duration-300"
          >
            <div className="flex items-center gap-5">
              <div className="w-12 h-12 border border-stone-800 flex items-center justify-center text-amber-500 group-hover:bg-amber-500 group-hover:text-stone-950 transition-colors duration-300">
                <Instagram size={18} />
              </div>
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-stone-500">
                  Instagram
                </div>
                <div className="text-stone-50 font-display text-lg mt-1">
                  @andooozy.cutzz
                </div>
              </div>
            </div>
            <span className="text-stone-500 text-sm group-hover:text-amber-500 transition-colors duration-300">
              open →
            </span>
          </a>

          <a
            href="https://www.snapchat.com/@andaz.a9"
            target="_blank"
            rel="noreferrer"
            data-testid="contact-snapchat"
            className="group flex items-center justify-between border border-stone-800 hover:border-amber-500/50 bg-stone-900/50 p-6 transition-colors duration-300"
          >
            <div className="flex items-center gap-5">
              <div className="w-12 h-12 border border-stone-800 flex items-center justify-center text-amber-500 group-hover:bg-amber-500 group-hover:text-stone-950 transition-colors duration-300">
                <Ghost size={18} />
              </div>
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-stone-500">
                  Snapchat
                </div>
                <div className="text-stone-50 font-display text-lg mt-1">
                  @andaz.a9
                </div>
              </div>
            </div>
            <span className="text-stone-500 text-sm group-hover:text-amber-500 transition-colors duration-300">
              open →
            </span>
          </a>

          <div className="border border-stone-800 bg-stone-900/50 p-6">
            <div className="flex items-center gap-5">
              <div className="w-12 h-12 border border-stone-800 flex items-center justify-center text-amber-500">
                <Clock size={18} />
              </div>
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-stone-500">
                  Hours
                </div>
                <div className="text-stone-300 mt-1 text-sm">
                  Thu · 12:00 PM – 6:00 PM · Fri · 3:00 PM – 8:00 PM · Sat &amp;
                  Sun · 10:00 AM – 11:00 PM (+$10 after 8 PM) · Mon / Tue / Wed
                  closed
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
